const YellowHeroShape = ({ ...props }) => {
  return (
    <svg
      width="155"
      height="261"
      viewBox="0 0 155 261"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M275.569 0.885154L175.536 260.238L0.946366 43.9306L275.569 0.885154Z"
        fill="#FEEE95"
      />
    </svg>
  );
};

export default YellowHeroShape;
